import * as React from 'react';
import styled from 'styled-components';

export interface LabelProps {
  /** Label Width */
  labelWidth?: number;
  /** Html Element Id */
  id?: string;
  /** Label Text */
  label: string;
}

const Wrapper = styled.div`
  display: flex;
  margin: 10px;
`;

const StyledLabel = styled<LabelProps, 'label'>('label')`
  margin-right: 10px;
  width: ${({ labelWidth = 120 }) => labelWidth}px;
  font-family: Roboto;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0px;
  text-align: left;
  color: #444a5a;
`;

export const Label = ({ labelWidth, id, label }: LabelProps) => (
  <StyledLabel id={id} labelWidth={labelWidth} label={label}>
    {label}
  </StyledLabel>
);

Label.defaultProps = {
  label: 'text',
};
